import {
  Box,
  Button,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { SelectField } from "@roc/ui";
import { observer } from "mobx-react";
import { useStore } from "@roc/client-portal-shared/hooks";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: "400px"
  },
  applyButton: {
    width: "300px"
  }
}));

interface TypeFiltersProps {
  onApply: () => void;
}

export const TypeFilters = observer(({ onApply }: TypeFiltersProps) => {
  const { compToolStoreV2: compToolStore } = useStore();

  const { compToolFiltersStore } = compToolStore;
  const { propertyTypeOptions } = compToolFiltersStore;
  const classes = useStyles();

  const selectedValues = compToolFiltersStore.form.fields.TYPE.values.value || [];

  return (
    <Box display="flex" flexDirection="column" gridGap="1rem" className={classes.root}>
      <Typography variant='body1' style={{ fontWeight: "bold" }}>
        Property Type
      </Typography>
      <SelectField
        options={propertyTypeOptions}
        testId={'propertyType'}
        value={selectedValues}
        onChange={value => {
          compToolFiltersStore.onFieldsChange('TYPE', 'values', value);
        }}
        fullWidth
        variant="outlined"
        multiple
        renderValue={(selected) =>
          selected.length === 0 ? (
            <span style={{ color: '#aaa' }}>Select one or more options</span>
          ) : (
            selected.join(', ')
          )
        }
      />
      <Box display="flex" justifyContent="center">
        <Button color="primary" variant="outlined" className={classes.applyButton} onClick={() => onApply && onApply()}>Apply</Button>
      </Box>
    </Box>
  );
});
